import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { accountTreeModel } from 'entities/account';
import { createPlayerTransactionRegistryModel } from 'entities/transaction';
import { playerPageModel } from './player-page-model';

const playerTransactionRegistryModel = createPlayerTransactionRegistryModel({
	$allAccountIds: accountTreeModel.$nodes.map((nodes) => Object.values(nodes).map(({ id }) => id)),
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: playerTransactionRegistryModel.registryModel.filters.accountIds.setValue,
});

chain(
	playerTransactionRegistryModel.registryModel.clearFilters,
	accountTreeModel.clearSelectedNodes,
);

sample({
	clock: [playerPageModel.$player, playerTransactionRegistryModel.registryModel.gate.open],
	source: playerPageModel.$player,
	filter: (player) => player !== null,
	fn: (player) => [player!.id],
	target: playerTransactionRegistryModel.registryModel.filters.playerIds.setValue,
});

sample({
	clock: playerTransactionRegistryModel.registryModel.filters.playerIds.$value,
	source: playerPageModel.$player,
	filter: (player, playerIds) =>
		player !== null && (playerIds.length !== 1 || playerIds[0] !== player.id),
	fn: (player) => [player!.id],
	target: playerTransactionRegistryModel.registryModel.filters.playerIds.setValue,
});

export const playerPageTransactionsModel = {
	playerTransactionRegistryModel,
};
